// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-input {
  border-bottom: 1px solid;
}

ion-item {
  font-size: 0.9rem;
  --min-height: 33px;
}

.editField > ion-item {
  --min-height: 33px;
}

ion-item.trasparent::part(native) {
  background: transparent;
}

.fielditem {
  --background: transparent;
  background: transparent;
}

.modelRowContainer > div:nth-of-type(odd) {
  background: #ececec;
}

.modelRowContainer > div:nth-of-type(even) {
  background: #ffffff;
}

.modelRowContainer .row:nth-of-type(odd) {
  background: #ececec;
}

.modelRowContainer .row:nth-of-type(even) {
  background: #ffffff;
}

.modelRowContainer > div:nth-of-type(odd) .fieldcell {
  background: #ececec;
}

.modelRowContainer > div:nth-of-type(even) .fieldcell {
  background: #ffffff;
}

.fieldcell:nth-of-type(odd) {
  border-right: 1px solid transparent;
  border-left: 1px solid transparent;
}

.whiteBg {
  background: #ffffff;
}

ion-item {
  padding: 0px;
}

.listTable td {
  border: 0px solid #ddd;
  line-height: 1.4rem;
}

.listTable td {
  border-bottom: 1px solid #ddd;
}

th {
  white-space: nowrap;
  padding: 5px;
}

.showScrollX {
  width: 100%;
  overflow-x: scroll;
  overscroll-behavior: contain;
}

.showScrollY {
  height: 700px;
  overflow-y: scroll;
  overscroll-behavior: contain;
}

.regTd > div:nth-of-type(odd) {
  background: #c7c7c7;
}

.regTd > div:nth-of-type(even) {
  background: #ffffff;
}

.regTd > ion-item {
  background: transparent;
}

.regTd > ion-item .item-inner {
  overflow: hidden;
  background: transparent;
}

.inTableImage {
  max-width: 30px;
  max-height: 30px;
  background: url("/assets/dashboard/back4.jpeg") no-repeat center center;
}

.inTableImage ion-img,
.inTableImage img {
  max-width: 60px;
  max-height: 60px;
}

.displayBlock {
  display: block;
}

.datarow:hover {
  border: 1px solid black;
}

.myrow {
  display: flex;
  border-bottom: 1px solid #ebebeb;
}

.fieldcell {
  text-align: center;
}

.displayNameField {
  box-shadow: rgb(45, 45, 45) 0px 0px 1px;
  border-width: 1px 0px 0px 0px;
}

.td1 {
  display: flex;
  flex-basis: 20px;
}

.td2 {
  display: flex;
  flex-basis: 20px;
}

.td12 .checkMarkInTd {
  display: none;
}

.td12:hover .checkMarkInTd {
  display: block;
}

.tdCheckBox {
  max-height: 70px;
}

.thDisplayName {
  flex-basis: 110px;
}

.td12 {
  position: relative;
  z-index: 22;
  align-content: flex-start;
  display: flex;
  flex-basis: 100px;
  background-color: #e1e1e1;
  width: 100px;
  max-width: 100px;
}

.td15 {
  z-index: 999999;
  flex-basis: 225px;
  max-width: 225px;
}

.draggableDiv {
  -webkit-user-select: none;
          user-select: none; /* Disable text selection */
  cursor: grab; /* Set cursor to grab when hovering over the div */
}

.draggableDiv:active {
  cursor: grabbing; /* Change cursor to grabbing while dragging */
}

.noScroll {
  animation: fadeInFromNone 0.5s ease-out;
}

@keyframes fadeInFromNone {
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: block;
    opacity: 0;
  }
  100% {
    display: block;
    opacity: 1;
  }
}
.onScroll {
  opacity: 0;
}

.tDtransition {
  transition: flex-basis 0.3s;
  transform: translateX(-3000);
  animation: translateXAnimation 2s none;
}

@keyframes translateXAnimation {
  0% {
    transform: translateX(0);
  }
}
.tDwidtherOnHover {
  transition: flex-basis 0.3s;
}

.tDwidtherOnHover:hover span {
  width: 35px;
  padding-left: 10px;
}

.tDwidtherOnHover:hover {
  flex-basis: 65px;
  cursor: pointer;
}

.tDwidtherOnHover1:hover {
  flex-basis: 90px;
  cursor: pointer;
}

.nottDwidtherChecked {
  flex-basis: 20px;
}

.tDwidtherChecked {
  flex-basis: 70px;
  cursor: pointer;
}

.tDwidtherChecked1 {
  flex-basis: 90px;
  cursor: pointer;
}

.disabledDiv {
  background-color: #d3e2ff;
}

.onFieldMouseOver {
  background-color: #fac75a;
}

.thButtonCOl {
  display: flex;
  flex-basis: 200px;
  max-width: 200px;
}

.smallTh {
  display: flex;
  flex-basis: 50px;
  max-width: 50px;
}

.th3 {
  display: flex;
  flex-basis: 300px;
  background: white;
  position: relative;
  z-index: 213332;
}

.td3 {
  display: flex;
  flex-basis: 300px;
  color: white;
  position: relative;
  z-index: 22;
  padding: 0px 3px;
}

.borderit {
  border-right: 1px solid #c7c7c7;
}

.mainBackcolor {
  background-color: var(--ion-color-secondary);
}

.mainBackcolor1 {
  background-color: var(--ion-color-warning);
}

.tdId {
  display: flex;
  flex-basis: 100px;
}

.fullFlex {
  flex-basis: 100%;
}

.Flex80 {
  flex-basis: 80%;
}

.sidecard {
  max-height: 661px;
  overflow-x: scroll;
}

.showOnHover {
  cursor: pointer;
}

.showOnHover:hover {
  border: 1px dashed;
  background-color: #efefef;
}

.showOnHoverDark:hover {
  background-color: #bebebe;
}

.showOnHover .showOnHoverSon {
  visibility: hidden;
}

.showOnHover .showOnHoverSonTop {
  top: -20px;
  position: relative;
  z-index: 111;
}

.showOnHover:hover .showOnHoverSon {
  visibility: visible;
}

.displayOnHover2 .displayOnHoverSon2 {
  display: none;
}

.displayOnHover2:hover .displayOnHoverSon2 {
  display: initial;
}

.tdFullOnHover:hover {
  min-width: -moz-fit-content;
  min-width: fit-content;
  flex-basis: auto !important;
}

.transitionFromHidden {
  width: 0;
}

.transitionFromHiddenOpen {
  transition: width 0.5s ease-in-out;
  width: auto;
}

.checkButton ion-button {
  height: 80px;
}

.checkButton ion-icon {
  font-size: 1.5rem;
}

.boxCheck ion-icon {
  visibility: hidden;
}

.boxCheck {
  width: 30px;
}

.boxCheck:hover {
  width: 70px;
  transition: width 0.3s;
}

.boxCheck:hover ion-icon {
  visibility: visible;
}

.middleBoxSmaller {
  width: 50px;
  transition: width 0.3s;
}

.field {
  vertical-align: center;
  border-width: 1px 1px 1px 0px;
  border-style: solid;
  border-color: #f6f6f6;
  border-radius: 14px;
  color: #474747;
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: hidden;
  max-height: 60px;
}

.listTableContainerSide {
  width: 100%;
  max-height: 700px;
  overflow-y: scroll;
}

.addNew {
  max-width: 700px;
  border-color: #a3a3a3;
  border: 1px dashed;
}

.boxView {
  max-width: 100%;
  float: left;
  padding: 8px;
  min-width: 300px;
}

.modelRow {
  min-width: 280px;
}

.cell {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  -webkit-box-orient: vertical;
}

@media screen and (max-width: 500px) {
  .modelRow {
    min-width: 100%;
  }
}
.modelRow {
  -webkit-transition-webkit-transition: opacity 0.5s ease-in-out;
  transition: opacity 1s ease-in-out;
  opacity: 1;
}

.opacityTransition {
  opacity: 0; /* start hidden */
  transition: opacity 13s ease-in-out;
}

.opacityTransition.visible {
  opacity: 1;
}

.modelRemoved {
  opacity: 0;
}

.onRefresh {
  opacity: 0;
}

.sticktTableHeader {
  position: fixed;
  z-index: 19911;
  margin-bottom: 8px;
  top: 60px;
}

.relationOpenMain {
  flex-basis: 80%;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/view-table/view-table.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;AACF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,uBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,uBAAA;AAFF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AAkBA;EAGE,mCAAA;EACA,kCAAA;AAjBF;;AAwBA;EACE,mBAAA;AArBF;;AAwBA;EACE,YAAA;AArBF;;AAyBA;EACE,sBAAA;EAEA,mBAAA;AAvBF;;AA0BA;EACE,6BAAA;AAvBF;;AA0BA;EACE,mBAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,WAAA;EACA,kBAAA;EACA,4BAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,kBAAA;EACA,4BAAA;AAvBF;;AAqCA;EACE,mBAAA;AAlCF;;AAqCA;EACE,mBAAA;AAlCF;;AAsCA;EACE,uBAAA;AAnCF;;AAuCA;EACE,gBAAA;EAEA,uBAAA;AArCF;;AAwCA;EACE,eAAA;EACA,gBAAA;EACA,uEAAA;AArCF;;AA0CA;;EAEE,eAAA;EACA,gBAAA;AAvCF;;AAkDA;EACE,cAAA;AA/CF;;AAkDA;EAEE,uBAAA;AAhDF;;AAmDA;EACE,aAAA;EAGA,gCAAA;AAlDF;;AAuDA;EAGE,kBAAA;AAtDF;;AAyDA;EACE,uCAAA;EACA,6BAAA;AAtDF;;AA8DA;EACE,aAAA;EACA,gBAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,gBAAA;AA3DF;;AA8DA;EACE,aAAA;AA3DF;;AA8DA;EACE,cAAA;AA3DF;;AA8DA;EACE,gBAAA;AA3DF;;AA8DA;EACE,iBAAA;AA3DF;;AA8DA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EAEA,yBAAA;EAEA,YAAA;EACA,gBAAA;AA7DF;;AAgEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AA7DF;;AAoEA;EACE,yBAAA;UAAA,iBAAA,EAAA,2BAAA;EACA,YAAA,EAAA,kDAAA;AAjEF;;AAoEA;EACE,gBAAA,EAAA,6CAAA;AAjEF;;AAoEA;EAIE,uCAAA;AAjEF;;AAoEA;EACE;IACE,aAAA;IACA,UAAA;EAjEF;EAoEA;IACE,cAAA;IACA,UAAA;EAlEF;EAqEA;IACE,cAAA;IACA,UAAA;EAnEF;AACF;AAsEA;EACE,UAAA;AApEF;;AAuEA;EACE,2BAAA;EACA,4BAAA;EACA,sCAAA;AApEF;;AAuEA;EACE;IACE,wBAAA;EApEF;AACF;AAuEA;EACE,2BAAA;AArEF;;AAwEA;EACE,WAAA;EACA,kBAAA;AArEF;;AAwEA;EACE,gBAAA;EACA,eAAA;AArEF;;AAwEA;EACE,gBAAA;EACA,eAAA;AArEF;;AAwEA;EACE,gBAAA;AArEF;;AAwEA;EACE,gBAAA;EACA,eAAA;AArEF;;AAwEA;EACE,gBAAA;EACA,eAAA;AArEF;;AAwEA;EACE,yBAAA;AArEF;;AAwEA;EACE,yBAAA;AArEF;;AAwEA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AArEF;;AAwEA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;AArEF;;AAyEA;EACE,aAAA;EAEA,iBAAA;EAIA,iBAAA;EACA,kBAAA;EACA,eAAA;AA1EF;;AA8EA;EACE,aAAA;EACA,iBAAA;EAEA,YAAA;EAIA,kBAAA;EACA,WAAA;EACA,gBAAA;AA/EF;;AAmFA;EACE,+BAAA;AAhFF;;AAmFA;EACE,4CAAA;AAhFF;;AAmFA;EACE,0CAAA;AAhFF;;AAmFA;EACE,aAAA;EACA,iBAAA;AAhFF;;AAmFA;EACE,gBAAA;AAhFF;;AAmFA;EACE,eAAA;AAhFF;;AAoFA;EACE,iBAAA;EACA,kBAAA;AAjFF;;AA8FA;EACE,eAAA;AA3FF;;AA8FA;EACE,kBAAA;EACA,yBAAA;AA3FF;;AA+FA;EACE,yBAAA;AA5FF;;AAgGA;EAEE,kBAAA;AA9FF;;AAiGA;EACE,UAAA;EACA,kBAAA;EACA,YAAA;AA9FF;;AAiGA;EACE,mBAAA;AA9FF;;AAiGA;EAEE,aAAA;AA/FF;;AAkGA;EACE,gBAAA;AA/FF;;AAkGA;EACE,2BAAA;EAAA,sBAAA;EACA,2BAAA;AA/FF;;AAmGA;EACE,QAAA;AAhGF;;AAmGA;EAKE,kCAAA;EACA,WAAA;AAhGF;;AAmGA;EACE,YAAA;AAhGF;;AAmGA;EACE,iBAAA;AAhGF;;AAmGA;EACE,kBAAA;AAhGF;;AAmGA;EACE,WAAA;AAhGF;;AAmGA;EACE,WAAA;EACA,sBAAA;AAhGF;;AAmGA;EACE,mBAAA;AAhGF;;AAmGA;EACE,WAAA;EACA,sBAAA;AAhGF;;AAmGA;EACE,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,gBAAA;AAjGF;;AAwGA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AArGF;;AA2GA;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;AAxGF;;AAgHA;EACE,eAAA;EAEA,WAAA;EAEA,YAAA;EACA,gBAAA;AA/GF;;AAkHA;EACE,gBAAA;AA/GF;;AAkHA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA,EAAA,qBAAA;EACA,4BAAA;AA/GF;;AAkHA;EACE;IACE,eAAA;EA/GF;AACF;AAkHA;EACE,8DAAA;EAIA,kCAAA;EACA,UAAA;AAhHF;;AAmHA;EACE,UAAA,EAAA,iBAAA;EAKA,mCAAA;AAhHF;;AAmHA;EACE,UAAA;AAhHF;;AAmHA;EACE,UAAA;AAhHF;;AAmHA;EACE,UAAA;AAhHF;;AAmHA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAhHF;;AAmHA;EACE,eAAA;AAhHF","sourcesContent":["ion-input {\n  border-bottom: 1px solid;\n}\n\nion-item {\n  font-size: 0.9rem;\n  --min-height: 33px;\n}\n\nspan {\n}\n\n.editField > ion-item {\n  --min-height: 33px;\n}\n\nion-item.trasparent::part(native) {\n  background: transparent;\n}\n\n.fielditem {\n  --background: transparent;\n  background: transparent;\n  //--min-height: auto;\n}\n\nth span {\n}\n\n.modelRowContainer > div:nth-of-type(odd) {\n  background: #ececec;\n}\n\n.modelRowContainer > div:nth-of-type(even) {\n  background: #ffffff;\n}\n\n.modelRowContainer .row:nth-of-type(odd) {\n  background: #ececec;\n}\n\n.modelRowContainer .row:nth-of-type(even) {\n  background: #ffffff;\n}\n\n.modelRowContainer > div:nth-of-type(odd) .fieldcell {\n  background: #ececec;\n}\n\n.modelRowContainer > div:nth-of-type(even) .fieldcell {\n  background: #ffffff;\n}\n\n.modelRow ion-item, .fieldcell .fieldcellItem {\n  //max-height: 31px;\n  //--min-height: 31px;\n}\n\n.fieldcell > div {\n  //background-color: white;\n}\n\n.fieldcell:nth-of-type(odd) {\n  //border-top: 1px solid #a1a1a1;\n  //border-bottom: 1px solid #a1a1a1;\n  border-right: 1px solid transparent;\n  border-left: 1px solid transparent;\n}\n\n.fieldcell:nth-of-type(even) {\n\n}\n\n.whiteBg {\n  background: #ffffff;\n}\n\nion-item {\n  padding: 0px;\n  //background-color: transparent;\n}\n\n.listTable td {\n  border: 0px solid #ddd;\n  //padding: 3.5px;\n  line-height: 1.4rem;\n}\n\n.listTable td {\n  border-bottom: 1px solid #ddd;\n}\n\nth {\n  white-space: nowrap;\n  padding: 5px;\n}\n\n.showScrollX {\n  width: 100%;\n  overflow-x: scroll;\n  overscroll-behavior: contain;\n}\n\n.showScrollY {\n  height: 700px;\n  overflow-y: scroll;\n  overscroll-behavior: contain;\n}\n\n\n.regTd {\n  //border: 1px solid #d3d3d3;\n  //padding: 3px;\n  //margin: 1px;\n  //border: 1px solid #aeaead;\n  //max-width: 140px;\n  //display: flex;\n}\n\n\n.regTd > div:nth-of-type(odd) {\n  background: #c7c7c7;\n}\n\n.regTd > div:nth-of-type(even) {\n  background: #ffffff;\n}\n\n\n.regTd > ion-item {\n  background: transparent;\n  //display: flex;\n}\n\n.regTd > ion-item .item-inner {\n  overflow: hidden;\n  //height: 70px;\n  background: transparent;\n}\n\n.inTableImage {\n  max-width: 30px;\n  max-height: 30px;\n  background: url('/assets/dashboard/back4.jpeg') no-repeat center center;\n  //padding-right: 3px;\n  //width: auto;\n}\n\n.inTableImage ion-img,\n.inTableImage img {\n  max-width: 60px;\n  max-height: 60px;\n}\n\n.myrowContainer {\n  //height: 31px;\n}\n\n.myrow:hover {\n  //background: #b1b1b1;\n}\n\n.displayBlock {\n  display: block;\n}\n\n.datarow:hover {\n  //background: #efefef;\n  border: 1px solid black;\n}\n\n.myrow {\n  display: flex;\n  //margin-top: 5px;\n  //display: -webkit-box;\n  border-bottom: 1px solid #ebebeb;\n  //display: flex;\n  //flex-wrap: wrap;\n}\n\n.fieldcell {\n  //height: 31px;\n  //max-height: 31px;\n  text-align: center;\n}\n\n.displayNameField {\n  box-shadow: rgb(45, 45, 45) 0px 0px 1px;\n  border-width: 1px 0px 0px 0px;\n}\n\n.myrow div {\n  //padding: 5px;\n\n}\n\n.td1 {\n  display: flex;\n  flex-basis: 20px;\n}\n\n.td2 {\n  display: flex;\n  flex-basis: 20px;\n}\n\n.td12 .checkMarkInTd {\n  display: none;\n}\n\n.td12:hover .checkMarkInTd {\n  display: block;\n}\n\n.tdCheckBox {\n  max-height: 70px;\n}\n\n.thDisplayName {\n  flex-basis: 110px;\n}\n\n.td12 {\n  position: relative;\n  z-index: 22;\n  align-content: flex-start;\n  display: flex;\n  flex-basis: 100px;\n  //padding: 5px;\n  background-color: #e1e1e1;\n\n  width: 100px;\n  max-width: 100px;\n}\n\n.td15 {\n  z-index: 999999;\n  flex-basis: 225px;\n  max-width: 225px;\n}\n\n.td12marginTop {\n  //margin-top: 5px;\n}\n\n.draggableDiv {\n  user-select: none; /* Disable text selection */\n  cursor: grab; /* Set cursor to grab when hovering over the div */\n}\n\n.draggableDiv:active {\n  cursor: grabbing; /* Change cursor to grabbing while dragging */\n}\n\n.noScroll {\n  -webkit-animation: fadeInFromNone 0.5s ease-out;\n  -moz-animation: fadeInFromNone 0.5s ease-out;\n  -o-animation: fadeInFromNone 0.5s ease-out;\n  animation: fadeInFromNone 0.5s ease-out;\n}\n\n@keyframes fadeInFromNone {\n  0% {\n    display: none;\n    opacity: 0;\n  }\n\n  1% {\n    display: block;\n    opacity: 0;\n  }\n\n  100% {\n    display: block;\n    opacity: 1;\n  }\n}\n\n.onScroll {\n  opacity: 0;\n}\n\n.tDtransition {\n  transition: flex-basis 0.3s;\n  transform: translateX(-3000);\n  animation: translateXAnimation 2s none;\n}\n\n@keyframes translateXAnimation {\n  0% {\n    transform: translateX(00);\n  }\n}\n\n.tDwidtherOnHover {\n  transition: flex-basis 0.3s;\n}\n\n.tDwidtherOnHover:hover span {\n  width: 35px;\n  padding-left: 10px;\n}\n\n.tDwidtherOnHover:hover {\n  flex-basis: 65px;\n  cursor: pointer;\n}\n\n.tDwidtherOnHover1:hover {\n  flex-basis: 90px;\n  cursor: pointer;\n}\n\n.nottDwidtherChecked {\n  flex-basis: 20px;\n}\n\n.tDwidtherChecked {\n  flex-basis: 70px;\n  cursor: pointer;\n}\n\n.tDwidtherChecked1 {\n  flex-basis: 90px;\n  cursor: pointer;\n}\n\n.disabledDiv {\n  background-color: #d3e2ff;\n}\n\n.onFieldMouseOver {\n  background-color: #fac75a;\n}\n\n.thButtonCOl {\n  display: flex;\n  flex-basis: 200px;\n  max-width: 200px;\n}\n\n.smallTh {\n  display: flex;\n  flex-basis: 50px;\n  max-width: 50px;\n}\n\n\n.th3 {\n  display: flex;\n  //background: white;\n  flex-basis: 300px;\n  //padding: 5px;\n  //color: white;\n  //height: 35px;\n  background: white;\n  position: relative;\n  z-index: 213332;\n  //background-color: rgba(42, 45, 69, 0.95);\n}\n\n.td3 {\n  display: flex;\n  flex-basis: 300px;\n  //padding: 5px;\n  color: white;\n  //height: 70px;\n  //background: white;\n  //background-color: rgba(42, 45, 69, 0.95);\n  position: relative;\n  z-index: 22;\n  padding: 0px 3px;\n}\n\n\n.borderit {\n  border-right: 1px solid #c7c7c7;\n}\n\n.mainBackcolor {\n  background-color: var(--ion-color-secondary);\n}\n\n.mainBackcolor1 {\n  background-color: var(--ion-color-warning);\n}\n\n.tdId {\n  display: flex;\n  flex-basis: 100px;\n}\n\n.fullFlex {\n  flex-basis: 100%;\n}\n\n.Flex80 {\n  flex-basis: 80%;\n}\n\n\n.sidecard {\n  max-height: 661px;\n  overflow-x: scroll;\n\n  //top: 63px;\n  //background: white;\n  //position: fixed;\n  //right: 0px;\n  //z-index: 100;\n  //width: 300px;\n  //padding: 5px;\n  //border: 1px solid;\n  //height: 100%;\n}\n\n.showOnHover {\n  cursor: pointer;\n}\n\n.showOnHover:hover {\n  border: 1px dashed;\n  background-color: #efefef;\n  //flex-basis: 200px;\n}\n\n.showOnHoverDark:hover {\n  background-color: #bebebe;\n}\n\n\n.showOnHover .showOnHoverSon {\n  //display: none;\n  visibility: hidden;\n}\n\n.showOnHover .showOnHoverSonTop {\n  top: -20px;\n  position: relative;\n  z-index: 111;\n}\n\n.showOnHover:hover .showOnHoverSon {\n  visibility: visible;\n}\n\n.displayOnHover2 .displayOnHoverSon2 {\n  //display: none;\n  display: none;\n}\n\n.displayOnHover2:hover .displayOnHoverSon2 {\n  display: initial;\n}\n\n.tdFullOnHover:hover {\n  min-width: fit-content;\n  flex-basis: auto !important;\n}\n\n\n.transitionFromHidden {\n  width: 0;\n}\n\n.transitionFromHiddenOpen {\n  -webkit-transition: width 0.5s ease-in-out;\n  -moz-transition: width 0.5s ease-in-out;\n  -ms-transition: width 0.5s ease-in-out;\n  -o-transition: width 0.5s ease-in-out;\n  transition: width 0.5s ease-in-out;\n  width: auto;\n}\n\n.checkButton ion-button {\n  height: 80px;\n}\n\n.checkButton ion-icon {\n  font-size: 1.5rem;\n}\n\n.boxCheck ion-icon {\n  visibility: hidden;\n}\n\n.boxCheck {\n  width: 30px;\n}\n\n.boxCheck:hover {\n  width: 70px;\n  transition: width 0.3s;\n}\n\n.boxCheck:hover ion-icon {\n  visibility: visible;\n}\n\n.middleBoxSmaller {\n  width: 50px;\n  transition: width 0.3s;\n}\n\n.field {\n  vertical-align: center;\n  border-width: 1px 1px 1px 0px;\n  border-style: solid;\n  border-color: #f6f6f6;\n  border-radius: 14px;\n  color: #474747;\n  white-space: nowrap;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  //position: relative;\n  max-height: 60px;\n  //overflow: auto;\n  //background: white;\n  //white-space: nowrap;\n  //padding: 7px 3px 0px 0px;\n}\n\n.listTableContainerSide {\n  width: 100%;\n  max-height: 700px;\n  overflow-y: scroll;\n}\n\n.addRelationModelButton {\n}\n\n.addNew {\n  max-width: 700px;\n  border-color: #a3a3a3;\n  border: 1px dashed;\n}\n\n.boxShow {\n  //margin: 0px 0px 19px 0px;\n  //border-bottom: 5px solid;\n}\n\n.boxView {\n  max-width: 100%;\n  //width: 100%;\n  float: left;\n  //max-width: 400px;\n  padding: 8px;\n  min-width: 300px;\n}\n\n.modelRow {\n  min-width: 280px;\n}\n\n.cell {\n  white-space: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* Limit to 2 lines */\n  -webkit-box-orient: vertical;\n}\n\n@media screen and (max-width: 500px) {\n  .modelRow {\n    min-width: 100%;\n  }\n}\n\n.modelRow {\n  -webkit-transition-webkit-transition: opacity 0.5s ease-in-out;\n  -moz-transition: opacity 1s ease-in-out;\n  -ms-transition: opacity 1s ease-in-out;\n  -o-transition: opacity 1s ease-in-out;\n  transition: opacity 1s ease-in-out;\n  opacity: 1;\n}\n\n.opacityTransition {\n  opacity: 0; /* start hidden */\n  -webkit-transition: opacity 13s ease-in-out;\n  -moz-transition: opacity 13s ease-in-out;\n  -ms-transition: opacity 13s ease-in-out;\n  -o-transition: opacity 13s ease-in-out;\n  transition: opacity 13s ease-in-out;\n}\n\n.opacityTransition.visible {\n  opacity: 1;\n}\n\n.modelRemoved {\n  opacity: 0;\n}\n\n.onRefresh {\n  opacity: 0;\n}\n\n.sticktTableHeader {\n  position: fixed;\n  z-index: 19911;\n  margin-bottom: 8px;\n  top: 60px;\n}\n\n.relationOpenMain {\n  flex-basis: 80%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
